module.exports = __webpack_public_path__ + "static/media/2.71e0140b.jpeg";